module.exports = __webpack_public_path__ + "img/news-12.2260510f.jpg";